import React from "react" // eslint-disable-line no-unused-vars
import injectSheet from "react-jss"
import cn from "classnames"
import { Bar } from "react-chartjs-2"
import setOptions from "../chartOptions"
import { onlyfyFullTheme } from "@xingternal/rebranding-adapter"

const styles = { container: { height: ({ height }) => height } }

const defaultDatasetOptions = {
  backgroundColor: onlyfyFullTheme.colors.linkText,
}

const parseData = (payload) => {
  payload.datasets.forEach((dataset, i) => {
    payload.datasets[i] = { ...defaultDatasetOptions, ...dataset }
  })

  return payload
}

const stackedOptions = {
  scales: {
    xAxes: [{ stacked: true }],
    yAxes: [{ stacked: true }],
  },
}

const BarChart = ({
  className,
  classes,
  data,
  height,
  options = {},
  stacked,
}) => {
  const chartOptions = stacked
    ? setOptions(stackedOptions)
    : setOptions(options)

  return (
    <div className={cn(classes.container, className)}>
      <Bar data={parseData(data)} options={chartOptions} height={height} />
    </div>
  )
}

BarChart.defaultProps = {
  height: 280,
  classes: {},
}

export const StyledBarChart = injectSheet(styles)(BarChart)
export default BarChart
